import $ from "jquery"

// core
import Imgix from "./core/Imgix"
import Waypoints from "./core/Waypoints"
import Announcement from "./core/Announcement"
import LightboxGallery from "./core/LightboxGallery"
import VideoControls from "./core/VideoControls"
import DropAHint from "./core/DropAHint"
import AjaxModalContent from "./core/AjaxModalContent"

// modules
import Accordion from "./modules/Accordion"
import ButtonModal from "./core/ButtonModal";
import FilterableAccordion from "./modules/FilterableAccordion";
import Grid from "./modules/Grid"
import Slider from "./modules/Slider"
import PrimaryNavigation from "./modules/PrimaryNavigation"
import GravityFormsValidator from "./modules/GravityFormsValidator"
import ReadMore from "./modules/ReadMore"
import SiteVitals from "./modules/SiteVitals"
import ProgressPlayButton from "./modules/ProgressPlayButton"

// Vitals
import { flashClass } from "./utility/UtilityFunctions.js"

// core
new Imgix()
new Waypoints()
new SiteVitals()
new DropAHint()
new LightboxGallery()
new ButtonModal()
new AjaxModalContent() // re-inits modules inside ajax-loaded modal content

// modules
// proposed method for calling modules?
const filterableAccordion = document.querySelectorAll(
    ".c-filterable-accordion"
);
filterableAccordion.forEach((element) => new FilterableAccordion(element));

const copyUrlButton = document.querySelectorAll("[data-module='url-copy-to-clipboard']")
copyUrlButton.forEach((element) => {
  element.addEventListener('click', (event) => {
    event.preventDefault();
    let activeClass = 'copied'

    flashClass(element, activeClass)

    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        // console.log('URL copied to clipboard!');
        return
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  });
});


document
	.querySelectorAll(".o-media-container__media--video-controls")
	.forEach((el) => {
		new ProgressPlayButton(el)
	})

new PrimaryNavigation()

document.querySelectorAll(".c-announcement-header-banner").forEach((el) => {
	new Announcement(el)
})

document.querySelectorAll("[data-module=accordion]").forEach((el) => {
	new Accordion(el)
})

document.querySelectorAll("[data-module=grid]").forEach((el) => {
	new Grid(el)
})
document.querySelectorAll("[data-module=slider]").forEach((el) => {
	new Slider(el)
})
// document.querySelectorAll("[data-module=lightbox-gallery],[data-module=slider]").forEach((el) => {
//     new LightboxGallery(el);
// })

document.querySelectorAll(".reveal-button").forEach((element) => {
	new ReadMore(element)
})

document.querySelectorAll(".o-form").forEach((element) => {
	new GravityFormsValidator({ el: element })
})

document.querySelectorAll("video[data-controls]").forEach((element) => {
    new VideoControls(element);
})

// trigger scrollSpecific additions onLoad (e.g. scrollDirection)
document.addEventListener("DOMContentLoaded", () => {
	window.dispatchEvent(new Event("optimisedScroll"));
});
